var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "23px",
    viewBox: "0 0 37 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2D9103B0-6826-4BA3-8CD3-B86C71D2EFD4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-1291.000000, -4022.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Radio",
    transform: "translate(1292.000000, 4023.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#9E9D9D",
    strokeWidth: 0.5,
    cx: 2.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    stroke: "#9E9D9D",
    strokeWidth: 0.5,
    cx: 2.5,
    cy: 9.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-9",
    stroke: "#464646",
    strokeWidth: 1.5,
    cx: 2.5,
    cy: 17.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.17961196e-16,
    y1: 5.5,
    x2: 35,
    y2: 5.5,
    id: "Line-5",
    stroke: "#ECECEC",
    strokeWidth: 0.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.17961196e-16,
    y1: 13.5,
    x2: 35,
    y2: 13.5,
    id: "Line-5-Copy",
    stroke: "#ECECEC",
    strokeWidth: 0.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.17961196e-16,
    y1: 21.5,
    x2: 35,
    y2: 21.5,
    id: "Line-5-Copy-2",
    stroke: "#ECECEC",
    strokeWidth: 0.3,
    strokeLinecap: "square"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/Radio.5cbcff1816dd2fe437850d54028049a6.svg";
export { ForwardRef as ReactComponent };